import { render, staticRenderFns } from "./Lobby4.vue?vue&type=template&id=2bdf6262"
import script from "./Lobby4.vue?vue&type=script&lang=js"
export * from "./Lobby4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports